
import isArray from 'lodash/isArray';
import Overlay from 'ol/Overlay';

import { getLayerIdFromFeatureForData } from './olUtils';

export default class OlMapPluginHint {

    constructor(options) {
        this._options = options || {};
        this._tooltip = null;
    }

    getMapLayerDefinition(layerId) {
        let mapLayerDefinition = null;
        if (isArray(this._options.mapLayersDefinition)) {
            this._options.mapLayersDefinition.forEach(item => {
                if (layerId && layerId.endsWith(item.id)) {
                    mapLayerDefinition = item;
                }
            });
        }
        return mapLayerDefinition;
    }

    getFeatureHint(features) {
        let featureHint = null;
        features.forEach(item => {
            let mapLayerDefinition = this.getMapLayerDefinition(getLayerIdFromFeatureForData(item));
            if (mapLayerDefinition && !featureHint) {
                featureHint =  {
                    feature: item,
                    hint: mapLayerDefinition.hint
                };
            }
        });
        return featureHint;
    }

    getHintContent(featureHint) {
        let content = featureHint.hint.template || '';
        let properties = featureHint.feature.getProperties();
        for (let name in properties) {
            content = content.replace(new RegExp(`@${name}@`, 'g'), properties[name]);
        }
        return content;
    }

    getOlMap() {
        return this._options.olMap;
    }

    getMap() {
        return this.getOlMap().getMap();
    }

    handlePointerMove = (evt) => {
        let map = this.getMap();

        let features = [];
        map.forEachFeatureAtPixel(evt.pixel, (feature) => {
            features.push(feature);
        });
        let featureHint = this.getFeatureHint(features);
        let displayHint = featureHint && featureHint.hint;
        if (displayHint)  {
            this._tooltip.setPosition(evt.coordinate);
            this._tooltip.getElement().innerHTML = this.getHintContent(featureHint);
            this.updateHintStyle(featureHint);
        }
        this._tooltip.getElement().style.display = displayHint ? '' : 'none';
        map.getTarget().style.cursor = displayHint ? 'pointer' : '';
    }

    init() {
        let map = this.getMap();

        this._tooltip = new Overlay({
            element: document.createElement('div'),
            positioning: 'bottom-center',
            stopEvent: false,
            offset: [0, -8],
        });
        map.addOverlay(this._tooltip);

        this._tooltip.getElement().style.backgroundColor = 'rgb(255, 255, 255)';
        this._tooltip.getElement().style.padding = '3px';

        map.on('pointermove', this.handlePointerMove);
    }

    updateHintStyle(featureHint) {
        if (featureHint.hint.style) {
            for (let name in featureHint.hint.style) {
                this._tooltip.getElement().style[name] = featureHint.hint.style[name];
            }
        }
    }
}
